import { Box, Grid, Typography } from "@mui/material";
import { CircledElement } from "pages/ProjectDashboard";

import createYourInsight from "assets/images/svgs/complete-insights.svg";
import createYourBrief from "assets/images/svgs/create-your-brief.svg";
import createYourSearch from "assets/images/svgs/start-your-search.svg";

interface StepPlaceholderProps {
    step: number;
    imgRoute: string;
    text: string;
}

const StepPlaceholder = ({ step, imgRoute, text }: StepPlaceholderProps) => {
    return (
        <Grid
            item
            sx={{
                mx: 1,
                padding: 3,
                display: "flex",
                borderRadius: 1,
                alignItems: "center",
                flexDirection: "column",
                backgroundColor: "common.white",
                boxShadow: "0px 2px 3px 0px #8582820d, 0px 6px 9px 0px #0000001A",
            }}
        >
            <Box display="flex" alignItems="center" mb={2}>
                <CircledElement size={34}>{step}</CircledElement>
                <Typography sx={{ ml: 2 }}>{text}</Typography>
            </Box>
            <Box sx={{ display: "flex", flex: 1, justifyContent: "center" }}>
                <img src={imgRoute} style={{ maxWidth: "90%" }} alt="" />
            </Box>
        </Grid>
    );
};

const LeadershipPlaceholder = () => {
    return (
        <Grid
            container
            sx={{
                maxWidth: 1170,
                margin: "auto",
                flexWrap: "nowrap",
                px: 2,
                py: 4,
                justifyContent: "space-between",
            }}
        >
            <StepPlaceholder step={1} text="Complete Your Insights" imgRoute={createYourInsight} />
            <StepPlaceholder step={2} text="Complete Your Brief" imgRoute={createYourBrief} />
            <StepPlaceholder step={3} text="Start Your Search" imgRoute={createYourSearch} />
        </Grid>
    );
};

export default LeadershipPlaceholder;
